import createReducer from "./../createReducer";
import { IValidationMessages } from "./types";
import { handlersConfigs } from "./handlers";
import { ValidationTypes } from "../fields/validationTypes";

export const validationInitialState: IValidationMessages = {
    [ValidationTypes.REQUIRED]: "This field must not be empty.",
    [ValidationTypes.LETTERS]: "Must contain letter.",
    [ValidationTypes.DIGITS]: "Must contain number.",
    [ValidationTypes.MIN_MAX_QUANTITY]: "Please enter a value between {min} and {max}.",
    [ValidationTypes.MIN_MAX_SIZE]: "Please upload a file between {min} and {max} {sizeType}.",
    [ValidationTypes.FILE_TYPE_FORMAT]: "Please upload a file of these {types / formats}.",
    [ValidationTypes.EMAIL]: "Please enter a valid Email address.",
    [ValidationTypes.URL]: "Please enter a valid URL.",
    [ValidationTypes.DOMAIN]: "Please enter a valid domain.",
    [ValidationTypes.MIN_MAX_DATE]: "Please enter a valid date.",
    [ValidationTypes.MIN_MAX_STRING_LENGTH]:
        "Please enter at least {min} characters and no more than {max} characters.",
    [ValidationTypes.MIN_MAX_OPTIONS]: "Please select at least {min} options and no more than {max} options",
};

export default createReducer(validationInitialState, handlersConfigs);
